import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {usePrepareFile} from '../use-prepare-file/use-prepare-file'
import {useImportFromFileStore} from '../import-from-file-store'
import {DropArea, MainMsg, SecondMsg} from './containers'
import FileIcon from './file-icon.svg'

export const SelectFile = observer(() => {
  const [state, store] = useImportFromFileStore()
  const {prepareFile} = usePrepareFile()

  return (
    <DropArea $isDragEnter={state.isDragEnter}>
      {state.isDragEnter ? (
        <SecondMsg>{Lang.msg.importFromFile.finishDragAndDrop}</SecondMsg>
      ) : (
        <>
          <MainMsg $marginBottom>
            <FileIcon className="mr-6" />
            {Lang.msg.importFromFile.selectFile}
          </MainMsg>
          <SecondMsg>{Lang.msg.importFromFile.dragAndDrop}</SecondMsg>
        </>
      )}
      <input
        type="file"
        accept=".csv"
        className="absolute cursor-pointer top-0 left-0 h-full w-full opacity-0"
        onDragEnter={() => store.onDragEnter()}
        onDrop={e => {
          store.onDrop()
          prepareFile(e.dataTransfer.files[0])
        }}
        onDragLeave={() => store.onDragLeave()}
        onChange={e => prepareFile(e?.target?.files?.[0])}
      />
    </DropArea>
  )
})
